module.exports = __webpack_public_path__ + "static/img/turntable.e899352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/turntable.png
// module id = zQBO
// module chunks = 215